import { ConfigT } from './validate';
import auConfig from './AU.json';
import nzConfig from './NZ.json';
import usConfig from './US.json';
import sgConfig from './SG.json';
import caConfig from './CA.json';
import ukConfig from './UK.json';
import devConfig from './DEV.json';
import frConfig from './FR.json';
import deConfig from './DE.json';
import esConfig from './ES.json';
import itConfig from './IT.json';
import seConfig from './SE.json';
import ieConfig from './IE.json';
import nlConfig from './NL.json';
import atConfig from './AT.json';
import beConfig from './BE.json';
import ptConfig from './PT.json';
import fiConfig from './FI.json';

let config = devConfig;

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-au' ||
  process.env.STORE === 'reebelo-au'
) {
  config = auConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-nz' ||
  process.env.STORE === 'reebelo-nz'
) {
  config = nzConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-us' ||
  process.env.STORE === 'reebelo-us'
) {
  config = usConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-ca' ||
  process.env.STORE === 'reebelo-ca'
) {
  config = caConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'quista' ||
  process.env.STORE === 'quista'
) {
  config = sgConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-uk' ||
  process.env.STORE === 'reebelo-uk'
) {
  config = ukConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-dev' ||
  process.env.STORE === 'reebelo-dev'
) {
  config = devConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-fr' ||
  process.env.STORE === 'reebelo-fr'
) {
  config = frConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-de' ||
  process.env.STORE === 'reebelo-de'
) {
  config = deConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-es' ||
  process.env.STORE === 'reebelo-es'
) {
  config = esConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-it' ||
  process.env.STORE === 'reebelo-it'
) {
  config = itConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-se' ||
  process.env.STORE === 'reebelo-se'
) {
  config = seConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-ie' ||
  process.env.STORE === 'reebelo-ie'
) {
  config = ieConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-nl' ||
  process.env.STORE === 'reebelo-nl'
) {
  config = nlConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-at' ||
  process.env.STORE === 'reebelo-at'
) {
  config = atConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-be' ||
  process.env.STORE === 'reebelo-be'
) {
  config = beConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-pt' ||
  process.env.STORE === 'reebelo-pt'
) {
  config = ptConfig as any;
}

if (
  process.env.NEXT_PUBLIC_STORE === 'reebelo-fi' ||
  process.env.STORE === 'reebelo-fi'
) {
  config = fiConfig as any;
}

if (Object.keys(config).length === 0) {
  throw Error(
    `No config is defined for store ${
      process.env.NEXT_PUBLIC_STORE || process.env.STORE
    }`,
  );
}

export const NON_TECH_CATEGORIES = [
  'Health & Beauty',
  'Skincare',
  'Makeup',
  'Hair Care',
  'Fragrance',
  'Health & Body',
  'Men - Health & Beauty',
  'Cosmetics',
  'Sports & Fitness',
  'Fitness',
  'Yoga Equipment',
  'Yoga Mats',
  'Yoga Accessories',
  'Cardio Equipment',
  'Fitness Equipment',
  'Outdoor Mats',
  'Yoga Bundles',
];

export const HEALTH_BEAUTY_CATEGORIES = [
  'Health & Beauty',
  'Skincare',
  'Makeup',
  'Hair Care',
  'Fragrance',
  'Health & Body',
  'Men - Health & Beauty',
  'Cosmetics',
];

export const POWER_TOOL_CATEGORIES = [
  'Power Tools',
  'Hardware Tools',
  'Power Saws',
  'Cordless drills',
  'Impact Wrenches',
  'Grinders',
  'Rotary Tools ',
  'Impact Drivers',
  'Nail & Staple Guns',
  'Air Tools & Air Compressors',
  'Chainsaws',
  'Pressure Washers',
  'Leaf Blowers and Vacuums',
  'String Trimmers',
  'Snow blowers',
  'Hedge Trimmers',
  'Gas Generators',
  'Electric Generators',
  'Flashlights',
  'Furniture Dollies & Castors',
  'Jacks, Stands, & Sawhorses',
  'Tool & Equipment Trolleys',
  'Wet & Dry Vacums',
  'Work Benches',
  'Batteries & Chargers',
  'Drill Sets',
  'Driver Set',
  'Power Stations',
  'Power Station bundles',
  'Power Station Accessories',
  'Cutting Tools',
  'Files',
  'Hammers & Mallets',
  'Clamps & Vises',
  'Saws',
  'Screwdrivers & Nutdrivers',
];

export const SPORT_FITNESS_CATEGORIES = [
  'E-scooters',
  'E-skateboards',
  'Electric Bikes',
  'Hoverboard Bundle',
  'Hoverboards',
  'Fitness',
  'Fitness Equipment',
  'Sports & Fitness',
  'Sports & Fitness Bundle',
  'Yoga',
  'Bikes',
  'Binoculars',
  'Golf',
  'Pickleball',
  'Snowboarding',
  'Ski',
  'Skiing',
  'Tennis',
  'Hiking Clothing',
  'Hiking Shoes',
  'Cycling Clothing',
  'Tactical Clothing',
  'Golf Clothing',
  'Snowboarding Helmets',
  'Ski Helmets',
  'Ski and Snowboarding Jackets',
  'Sports Equipment',
  'Clothing and Gear',
  'Scopes',
  'Tent',
  'Golf Accessories',
  'Golf Balls',
  'Golf Carts',
  'Golf Club Bags',
  'Golf Clubs',
  'Golf Training Equipment',
  'On-Course Golf Accessories',
  'Yoga Accessories',
  'Yoga Equipment',
  'Yoga Mats',
];

export default config as ConfigT;
